import Vue from 'vue';
import Router from 'vue-router';
import MenuAPI from "@/web-framework/api/menu.js";

Vue.use(Router);

let publicMenus = MenuAPI.initFrameworkMenus(PUBLIC_ROUTES);
console.log("tttttt");
console.log(publicMenus);

let routes = [{
        "path": "/diagram_score_analysis",
        "component": () =>
            import ("@/pages/front/diagram_score_analysis.vue"),
        "name": "diagram_score_analysis",
        "meta": {
            "title": "成绩分析"
        }
    },
    {
        "path": "/diagram_cutoff_score_line",
        "component": () =>
            import ("@/pages/front/diagram_cutoff_score_line.vue"),
        "name": "diagram_cutoff_score_line",
        "meta": {
            "title": "投档线分析"
        }
    },
    {
        path: '/g/product',
        name: 'PCProduct',
        component: () =>
            import ('@/pages/front/g/product.vue'),
        meta: {
            title: '优选志愿填报系统',
            requiresAuth: false
        }
    },
    {
        path: '/g/2027tg',
        name: 'tg2027',
        component: () =>
            import ('@/pages/front/g/buy_AgentGroup2027/login.vue')
    },
    {
        path: '/g/2027tg/purchase',
        name: 'tg2027Purchase',
        component: () =>
            import ('@/pages/front/g/buy_AgentGroup2027/groupBuy2027.vue')
    },
    {
        path: '/g/preview2027',
        name: 'Preview2027PreorderLogin',
        component: () =>
            import ('@/pages/front/g/buy_PreOrderCode2027/login.vue')
    },
    {
        path: '/g/preview2027/purchase',
        name: 'Preview2027PreorderPurchase',
        component: () =>
            import ('@/pages/front/g/buy_PreOrderCode2027/preview2027.vue')
    },
    {
        path: '/g/2027edition',
        redirect: '/g/2027edition/login'
    },
    {
        path: '/g/2027edition/login',
        name: 'Preview2027Login',
        component: () =>
            import ('@/pages/front/g/buy2027/login.vue'),
        meta: {
            title: '2027版优选志愿系统',
            requiresAuth: false
        }
    },
    {
        path: '/g/2027edition/purchase',
        name: 'Preview2027Purchase',
        component: () =>
            import ('@/pages/front/g/buy2027/purchase.vue'),
        meta: {
            title: '购买2027版优选志愿系统',
            requiresAuth: false
        }
    },
    {
        path: '/g/mp',
        name: 'MPView',
        component: () =>
            import ('@/pages/front/g/buy_MiniProgram/login.vue'),
        meta: {
            title: '购买2027版优选志愿系统',
            requiresAuth: false
        }
    },
    {
        path: '/g/mp/purchase',
        name: 'MPPurchase',
        component: () =>
            import ('@/pages/front/g/buy_MiniProgram/purchase.vue'),
        meta: {
            title: '购买2027版优选志愿系统',
            requiresAuth: false
        }
    }
].concat(publicMenus);

export const constantRoutes = routes;

const createRouter = () =>
    new Router({
        mode: 'history',
        scrollBehavior: () => ({
            y: 0
        }),
        routes: constantRoutes
    });

const router = createRouter();

router.$addRoutes = (params) => {
    router.matcher = new Router({ mode: 'history' }).matcher
    router.addRoutes(params);
}

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}
export default router;